export default __webpack_public_path__ + "static/media/phone.9d0a0c10.svg";